<template>

    <spinner-until :condition="loaded">

        <div class="my-questionnaire-list mt-0">

            <!-- summary message -->

            <div class="row py-3 align-items-center">
                <div class="col"
                     v-if="uncompletedSurveys && !uncompletedSurveys.length">
                    {{ $i18n.gt('MESSAGE_NO_QUESTIONNAIRE_INVITATIONS') }}
                </div>
                <div class="col"
                     v-else>
                    {{ $i18n.gt('MESSAGE_QUESTIONNAIRE_INVITATIONS') }}
                </div>
            </div>

            <div class="py-3"
                 v-for="s in uncompletedSurveys" :key="s.id">
                <b-row>
                    <b-col>
                        <h4>{{ $i18n.gt(`QUESTIONNAIRE_TITLE_${s.questionnaire_code}`) }}</h4>
                    </b-col>
                </b-row>

                <!--  unstarted questionnaire -->

                <b-row v-if="!s.started">
                    <b-col>
                        <b-badge variant="danger">
                            {{ $i18n.gt('MESSAGE_LAST_QUESTIONNAIRE_UNSTARTED') }}
                        </b-badge>
                    </b-col>
                    <b-col class="text-right">
                        <b-btn size="sm"
                               :to="`/survey/fill/id/${s.survey_id}/participantId/${participant.id}`">
                            {{ $i18n.gt('LABEL_START_QUESTIONNAIRE') }}
                        </b-btn>
                    </b-col>
                </b-row>

                <!--  incomplete questionnaire -->

                <b-row v-else-if="!s.is_complete">
                    <b-col>
                        <b-badge variant="warning">
                            {{ $i18n.gt('MESSAGE_LAST_QUESTIONNAIRE_INCOMPLETE') }}
                        </b-badge>
                    </b-col>
                    <b-col class="text-right">
                        <b-btn size="sm"
                               :to="`/survey/fill/id/${s.survey_id}/participantId/${participant.id}`">
                            {{ $i18n.gt('LABEL_RESUME_QUESTIONNAIRE') }}
                        </b-btn>
                    </b-col>
                </b-row>
            </div>

        </div>
    </spinner-until>

</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'

/**
 * Component with links for patient to start/resume invited questionnaires
 */
export default Vue.extend({
    name: 'MyQuestionnaireList',
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        loaded() {
            return !!this.participant.id && !!this.participant.latestSurveys
        },
        uncompletedSurveys() {
            return _.filter(this.participant.latestSurveys, (s) => {
                return !!s.survey_id && !s.is_complete
            })
        }
    },
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.my-questionnaire-list {

    > div {
        &:nth-child(even) {
            background-color: var(--stripe-background);
            border-top: solid 1px #ddd;
            border-bottom: solid 1px #ddd;
        }
        &:last-child {
            border-bottom: none;
        }
    }
}

</style>
